import React, { useMemo, useState } from "react";
import hadaLogo from "../img/Hada1_1.png";
// import heroImage from "../img/hero.png"; // descomenta si sí existe

const perfumes = [
      // DAMA
      { cat: "dama", name: "Ary", inspo: "Ari", brand: "Ariana Grande", desc: "Dulce y femenino con notas de pera, frambuesa y un corazón de iris envuelto en almizcle cálido.", notes: ["Pera", "Iris", "Almizcle"] },
      { cat: "dama", name: "God Woman", inspo: "God is a Woman", brand: "Ariana Grande", desc: "Floral amaderado con bergamota fresca, jazmín luminoso y sándalo cremoso.", notes: ["Bergamota", "Jazmín", "Sándalo"] },
      { cat: "dama", name: "Arian Nub", inspo: "Cloud", brand: "Ariana Grande", desc: "Nube de vainilla y coco con toques de lavanda y madera de cedro suave.", notes: ["Lavanda", "Coco", "Vainilla"] },
      { cat: "dama", name: "Imagination Spears", inspo: "Fantasy", brand: "Britney Spears", desc: "Frutal goloso con kiwi, litchi y magnolia sobre una base de almizcle blanco.", notes: ["Litchi", "Magnolia", "Almizcle"] },
      { cat: "dama", name: "Bur Gold", inspo: "Burberry Goddess", brand: "Burberry", desc: "Lavanda intensa y etérea con notas de vainilla tostada y ámbar dorado.", notes: ["Lavanda", "Vainilla", "Ámbar"] },
      { cat: "dama", name: "Love Love", inspo: "Amor Amor", brand: "Cacharel", desc: "Floral juvenil con grosella, bergamota y rosa sobre base de vainilla.", notes: ["Grosella", "Rosa", "Vainilla"] },
      { cat: "dama", name: "BLUSH", inspo: "La Bomba", brand: "Carolina Herrera", desc: "Floral empolvado y delicado con notas de peonía, lychee y un corazón de rosa sobre una base de almizcle suave y sándalo cremoso.", notes: ["Peonía", "Lychee", "Rosa"] },
      { cat: "dama", name: "Eternal Calv", inspo: "Eternity", brand: "Calvin Klein", desc: "Floral verde y limpio con lirio del valle, mandarina y sándalo clásico.", notes: ["Lirio del valle", "Mandarina", "Sándalo"] },
      { cat: "dama", name: "Good Femes Classic", inspo: "Good Girl", brand: "Carolina Herrera", desc: "Floral oscuro y seductor: jazmín de tuberosa, cacao y almendra tostada.", notes: ["Jazmín", "Cacao", "Almendra"] },
      { cat: "dama", name: "Two One Two", inspo: "212", brand: "Carolina Herrera", desc: "Fresco y urbano con notas de camellia, rosa y almizcle suave.", notes: ["Camellia", "Rosa", "Almizcle"] },
      { cat: "dama", name: "Two One Two Alluring", inspo: "212 Sexy", brand: "Carolina Herrera", desc: "Sensual y especiado con gardenias, pimienta rosa y maderas cálidas.", notes: ["Gardenia", "Pimienta rosa", "Maderas"] },
      { cat: "dama", name: "Good Femes", inspo: "Good Girl Supreme", brand: "Carolina Herrera", desc: "Más suave y luminoso que su predecesora, con jazmín, nardos y base de tonka.", notes: ["Nardos", "Jazmín", "Tonka"] },
      { cat: "dama", name: "Classic No.5", inspo: "Chanel No. 5", brand: "Chanel", desc: "El icono atemporal: aldehídos florales, ylang-ylang, jazmín y fondo de vetiver.", notes: ["Aldehídos", "Ylang-ylang", "Vetiver"] },
      { cat: "dama", name: "Be Tasty", inspo: "Be Delicious Bright Crush", brand: "DKNY", desc: "Manzana fresca y jugosa con jazmín, mandarina y cedro cremoso.", notes: ["Manzana", "Jazmín", "Cedro"] },
      { cat: "dama", name: "Feel Temp", inspo: "Be Tempted", brand: "DKNY", desc: "Frutal floral moderno con frutos rojos, iris y almizcle envolvente.", notes: ["Frutos rojos", "Iris", "Almizcle"] },
      { cat: "dama", name: "Gabandol Ocean", inspo: "Light Blue", brand: "Dolce & Gabbana", desc: "Fresco marino con sicilian citrus, bambú, manzana verde y rosa blanca.", notes: ["Cítricos", "Bambú", "Rosa"] },
      { cat: "dama", name: "Gabandol Queen", inspo: "Q", brand: "Dolce & Gabbana", desc: "Floral sofisticado con gardenia, lirio y base de sándalo y ámbar.", notes: ["Gardenia", "Lirio", "Ámbar"] },
      { cat: "dama", name: "Scarlet Dor", inspo: "Red Door", brand: "Elizabeth Arden", desc: "Floral clásico y elegante con rosa, lirio del valle y ylang-ylang.", notes: ["Rosa", "Lirio", "Ylang-ylang"] },
      { cat: "dama", name: "Sakura Japan", inspo: "Cherry in Japan", brand: "ESCADA", desc: "Floral frutal con cerezo japonés, flor de loto y almizcle sheer.", notes: ["Cerezo", "Loto", "Almizcle"] },
      { cat: "dama", name: "Oceandise", inspo: "Pacific Paradise", brand: "ESCADA", desc: "Tropical y refrescante con maracuyá, orquídea y madera de teca.", notes: ["Maracuyá", "Orquídea", "Teca"] },
      { cat: "dama", name: "Aqua Classic", inspo: "Acqua di Gio", brand: "Giorgio Armani", desc: "Fresco mediterráneo con cítricos, jacinto marino y almizcle blanco.", notes: ["Cítricos", "Jacinto", "Almizcle"] },
      { cat: "dama", name: "True Way", inspo: "My Way Ylang", brand: "Giorgio Armani", desc: "Floral solar con ylang-ylang, tuberosa y vainilla en base amaderada.", notes: ["Ylang-ylang", "Tuberosa", "Vainilla"] },
      { cat: "dama", name: "Gucilty", inspo: "Gucci Guilty", brand: "Gucci", desc: "Floral frutal audaz con mandarina, lila y fondo de melocotón y almizcle.", notes: ["Mandarina", "Lila", "Melocotón"] },
      { cat: "dama", name: "Boss Citrus", inspo: "Boss Orange", brand: "Hugo Boss", desc: "Cítrico-floral vibrante con naranja, melocotón y un corazón de magnolia.", notes: ["Naranja", "Melocotón", "Magnolia"] },
      { cat: "dama", name: "Shadow Ros", inspo: "Ombre Rose", brand: "Jean Charles Brosseau", desc: "Rosa polvoreada y romántica sobre fondo de sándalo y almizcle sedoso.", notes: ["Rosa", "Polvos", "Sándalo"] },
      { cat: "dama", name: "All Hallows Eve", inspo: "Halloween", brand: "Jesus del Pozo", desc: "Oriental especiado con flor de maracuyá, madera y ámbar oscuro.", notes: ["Maracuyá", "Especias", "Ámbar"] },
      { cat: "dama", name: "Kit Perr", inspo: "Meow", brand: "Katy Perry", desc: "Frutal goloso con mora, melocotón y crema sobre base de almizcle cálido.", notes: ["Mora", "Melocotón", "Crema"] },
      { cat: "dama", name: "Beautiful Life", inspo: "La Vie Est Belle", brand: "Lancôme", desc: "Iris gourmand icónico con pralinée, currant negro y patchouli suave.", notes: ["Iris", "Pralinée", "Patchouli"] },
      { cat: "dama", name: "Jara", inspo: "Yara", brand: "Lattafa", desc: "Oriental floral con frutos del bosque, jazmín y base de oud amaderado.", notes: ["Frutos rojos", "Jazmín", "Oud"] },
      { cat: "dama", name: "Spell You", inspo: "Spell On You", brand: "Louis Vuitton", desc: "Sensual y misterioso: rosa turca, pachulí y ámbar negro.", notes: ["Rosa turca", "Pachulí", "Ámbar"] },
      { cat: "dama", name: "Daisy Sun", inspo: "Daisy Eau So Fresh Sunshine", brand: "Marc Jacobs", desc: "Floral frutal soleado con grosella, magnolia y fondo de almizcle cálido.", notes: ["Grosella", "Magnolia", "Almizcle"] },
      { cat: "dama", name: "Play 2", inspo: "Toy 2", brand: "Moschino", desc: "Frutal especiado con melocotón, especias dulces y base de cedro.", notes: ["Melocotón", "Especias", "Cedro"] },
      { cat: "dama", name: "Can Can", inspo: "Can Can", brand: "Paris Hilton", desc: "Frutal floral festivo con mandarina, peonía y base de sándalo.", notes: ["Mandarina", "Peonía", "Sándalo"] },
      { cat: "dama", name: "Icon Paris", inspo: "Paris Hilton", brand: "Paris Hilton", desc: "Floral luminoso con manzana, jazmín y almizcle blanco suave.", notes: ["Manzana", "Jazmín", "Almizcle"] },
      { cat: "dama", name: "Fresh", inspo: "Ralph Fresh", brand: "Ralph Lauren", desc: "Acuoso y limpio con pepino, mandarina y flores blancas.", notes: ["Pepino", "Mandarina", "Flores blancas"] },
      { cat: "dama", name: "Lau Classic Women", inspo: "Ralph", brand: "Ralph Lauren", desc: "Floral clásico americano con rosa, violeta y musgo de roble.", notes: ["Rosa", "Violeta", "Musgo"] },
      { cat: "dama", name: "Selene Classic", inspo: "Selena Gomez", brand: "Selena Gomez", desc: "Dulce y luminoso con violeta, pera y un corazón de jazmín y cedro.", notes: ["Violeta", "Pera", "Jazmín"] },
      { cat: "dama", name: "Hilfgirl", inspo: "Tommy Girl", brand: "Tommy Hilfiger", desc: "Floral verde y fresco con manzana, mandarina y gardenia.", notes: ["Manzana", "Gardenia", "Fressia"] },
      { cat: "dama", name: "Green Valentin Girl", inspo: "Valentino Donna Born in Roma Green Stravaganza", brand: "Valentino", desc: "Verde y floral: te verde, bergamota y flores blancas silvestres.", notes: ["Té verde", "Bergamota", "Flores silvestres"] },
      { cat: "dama", name: "Valentino Girl", inspo: "Valentino Donna Born in Roma", brand: "Valentino", desc: "Floral moderno con peonía, jengibre y vainilla tonka.", notes: ["Peonía", "Jengibre", "Tonka"] },
      { cat: "dama", name: "Radiant Crystal", inspo: "Bright Crystal Absolu", brand: "Versace", desc: "Floral frutal intenso con granada, yuzu y peonía sobre base de almizcle.", notes: ["Granada", "Yuzu", "Peonía"] },
      { cat: "dama", name: "Dylan Azure", inspo: "Dylan Blue", brand: "Versace", desc: "Acuático floral con cassis, jacinto y pachulí oscuro.", notes: ["Cassis", "Jacinto", "Pachulí"] },
      { cat: "dama", name: "Free Intense", inspo: "Libre Intense Women", brand: "YSL", desc: "Lavanda intensa y femenina con lavanda, naranja amarga y vainilla negra.", notes: ["Lavanda", "Naranja amarga", "Vainilla"] },

      // CABALLERO
      { cat: "caballero", name: "Velvet Night", inspo: "9PM", brand: "Afnan", desc: "Oriental especiado y envolvente para la noche, con especias, lavanda y ámbar.", notes: ["Especias", "Lavanda", "Ámbar"] },
      { cat: "caballero", name: "Club Night", inspo: "Club de Nuit Intense Man", brand: "Armaf", desc: "Fresco y elegante con notas de abedul, pomelo y ámbar gris.", notes: ["Abedul", "Pomelo", "Ámbar gris"] },
      { cat: "caballero", name: "Imperial King", inspo: "Bharara", brand: "Bharara", desc: "Amaderado especiado con sándalo, pimienta negra y cuero.", notes: ["Sándalo", "Pimienta", "Cuero"] },
      { cat: "caballero", name: "Bgari Homme", inspo: "Bulgari Pour Homme", brand: "Bulgari", desc: "Limpio y sofisticado con té verde, bergamota y cedro blanco.", notes: ["Té verde", "Bergamota", "Cedro"] },
      { cat: "caballero", name: "Bulgari Ocean", inspo: "Marine", brand: "Bvlgari", desc: "Marino y fresco con algas, cítricos y madera ligera.", notes: ["Algas", "Cítricos", "Madera"] },
      { cat: "caballero", name: "Rebels Boys", inspo: "Bad Boys Are No Good…", brand: "By Kilian", desc: "Cálido y rebelde: especias, cuero y notas de tabaco dulce.", notes: ["Especias", "Cuero", "Tabaco"] },
      { cat: "caballero", name: "Eternal Calv", inspo: "Eternity for Men", brand: "Calvin Klein", desc: "Fresco aromático clásico con mandarina, lavanda y sándalo.", notes: ["Mandarina", "Lavanda", "Sándalo"] },
      { cat: "caballero", name: "Coro Carinto", inspo: "Carlo Corinto", brand: "Carlo Corinto", desc: "Clásico amaderado con bergamota, musgo y base de madera de pino.", notes: ["Bergamota", "Musgo", "Pino"] },
      { cat: "caballero", name: "Dark VIP 212", inspo: "212 Vip Black", brand: "Carolina Herrera", desc: "Gourmand oscuro y masculino con notas de champagne, especias y ámbar.", notes: ["Champagne", "Especias", "Ámbar"] },
      { cat: "caballero", name: "Rebel Boy", inspo: "Bad Boy", brand: "Carolina Herrera", desc: "Fresco y oscuro: cactus marino, salvia y base de vetiver.", notes: ["Cactus", "Salvia", "Vetiver"] },
      { cat: "caballero", name: "Herr For Men", inspo: "Herrera for Men", brand: "Carolina Herrera", desc: "Aromático amaderado con mandarina, lavanda y cedro.", notes: ["Mandarina", "Lavanda", "Cedro"] },
      { cat: "caballero", name: "Noir 12.12", inspo: "212 Men", brand: "Carolina Herrera", desc: "Urbano y dinámico con notas cítricas, almizcle marino y pimienta blanca.", notes: ["Cítricos", "Almizcle", "Pimienta"] },
      { cat: "caballero", name: "H Gentleman", inspo: "CH Men", brand: "Carolina Herrera", desc: "Aromático fougère con notas de menta, tabaco y patchouli.", notes: ["Menta", "Tabaco", "Patchouli"] },
      { cat: "caballero", name: "12 VIP Guys", inspo: "212 VIP Men", brand: "Carolina Herrera", desc: "Sofisticado y brillante con cardamomo, especias y base de ámbar.", notes: ["Cardamomo", "Especias", "Ámbar"] },
      { cat: "caballero", name: "12 Guy Victory", inspo: "212 VIP Men Wins", brand: "Carolina Herrera", desc: "Elegante y deportivo: bergamota, madera de cuero y almizcle blanco.", notes: ["Bergamota", "Cuero", "Almizcle"] },
      { cat: "caballero", name: "Blue Sea", inspo: "Bleu de Chanel", brand: "Chanel", desc: "El referente masculino moderno: cítricos, especias secas y vetiver.", notes: ["Cítricos", "Vetiver", "Especias"] },
      { cat: "caballero", name: "Aventis Royal", inspo: "Aventus", brand: "Creed", desc: "Frutal amaderado icónico: piña, abedul ahumado y ámbar gris.", notes: ["Piña", "Abedul", "Ámbar gris"] },
      { cat: "caballero", name: "Diesl Bad", inspo: "Diesel Bad", brand: "Diesel", desc: "Cuero rebelde con notas de tabaco, tomillo y almizcle oscuro.", notes: ["Cuero", "Tabaco", "Tomillo"] },
      { cat: "caballero", name: "Wild EDP", inspo: "Sauvage EDP", brand: "Dior", desc: "El perfume más popular del mundo: bergamota amaderada, nuez moscada y ámbar.", notes: ["Bergamota", "Nuez moscada", "Ámbar"] },
      { cat: "caballero", name: "Italian Blue", inspo: "Light Blue Italian Zest pour Homme", brand: "Dolce & Gabbana", desc: "Cítrico marino con madera de mandarina, grapefruit y cedro italiano.", notes: ["Mandarina", "Grapefruit", "Cedro"] },
      { cat: "caballero", name: "Gabandol", inspo: "The One for Men", brand: "Dolce & Gabbana", desc: "Tabaco oriental con canela, cardamomo y base de ámbar cálido.", notes: ["Tabaco", "Cardamomo", "Ámbar"] },
      { cat: "caballero", name: "Aqua Eternity", inspo: "Acqua di Giò Profumo", brand: "Giorgio Armani", desc: "Marino intenso con incienso, bergamota y patchouli oscuro.", notes: ["Incienso", "Bergamota", "Patchouli"] },
      { cat: "caballero", name: "Aqua Classic", inspo: "Acqua di Giò", brand: "Giorgio Armani", desc: "El clásico marino masculino por excelencia: cítrico, marino y limpio.", notes: ["Cítricos", "Mar", "Almizcle"] },
      { cat: "caballero", name: "Aqua Sea Light", inspo: "Acqua di Giò Profondo Lights", brand: "Giorgio Armani", desc: "Fresco marino luminoso con bergamota, lavanda y musgo marino.", notes: ["Bergamota", "Lavanda", "Musgo"] },
      { cat: "caballero", name: "Aqua Parfum", inspo: "Acqua di Giò EDP", brand: "Giorgio Armani", desc: "Marino profundo con notas de labdanum, incienso y patchouli.", notes: ["Labdanum", "Incienso", "Patchouli"] },
      { cat: "caballero", name: "Guc Custom Fit", inspo: "Gucci Made to Measure", brand: "Gucci", desc: "Lavanda especiada con iris, mandarina y vetiver sofisticado.", notes: ["Lavanda", "Iris", "Vetiver"] },
      { cat: "caballero", name: "Dark Night", inspo: "Drakkar Noir", brand: "Guy Laroche", desc: "Aromático clásico con lavanda, artemisa y base de cuero.", notes: ["Lavanda", "Artemisa", "Cuero"] },
      { cat: "caballero", name: "Boss Fragrance", inspo: "Boss The Scent", brand: "Hugo Boss", desc: "Especiado y seductor con jengibre, manuka y cuero.", notes: ["Jengibre", "Manuka", "Cuero"] },
      { cat: "caballero", name: "Boss Chill", inspo: "Hugo Iced", brand: "Hugo Boss", desc: "Mentolado y fresco con menta ártica, manzana verde y madera.", notes: ["Menta", "Manzana", "Madera"] },
      { cat: "caballero", name: "Hugh", inspo: "Hugo", brand: "Hugo Boss", desc: "Fresco moderno con manzana verde, lavanda y musgo.", notes: ["Manzana", "Lavanda", "Musgo"] },
      { cat: "caballero", name: "Boss Man Intense", inspo: "Hugo Man Extreme", brand: "Hugo Boss", desc: "Fougère intenso con lavanda, geranio y ámbar seco.", notes: ["Lavanda", "Geranio", "Ámbar"] },
      { cat: "caballero", name: "Boss Extreme", inspo: "Boss Bottled Intense", brand: "Hugo Boss", desc: "Amaderado oriental con manzana, vainilla y vetiver.", notes: ["Manzana", "Vainilla", "Vetiver"] },
      { cat: "caballero", name: "Le Male Pilot", inspo: "Le Male Aviator", brand: "Jean Paul Gaultier", desc: "Lavanda intensa y especiada con notas de benjuí y tonka.", notes: ["Lavanda", "Benjuí", "Tonka"] },
      { cat: "caballero", name: "The Male Potion", inspo: "Le Male Elixir", brand: "Jean Paul Gaultier", desc: "Amberizado oscuro con lavanda, vainilla y cuero oscuro.", notes: ["Lavanda", "Vainilla", "Cuero"] },
      { cat: "caballero", name: "Scandal Men", inspo: "Scandal pour Homme", brand: "Jean Paul Gaultier", desc: "Dulce y audaz con bergamota, lavanda y notas de jarabe.", notes: ["Bergamota", "Lavanda", "Jarabe"] },
      { cat: "caballero", name: "Noir Interdite", inspo: "L.12.12 Noir", brand: "Lacoste", desc: "Fresco oscuro con pimienta negra, ámbar y cedro.", notes: ["Pimienta", "Ámbar", "Cedro"] },
      { cat: "caballero", name: "Laclass", inspo: "Lacoste pour Homme", brand: "Lacoste", desc: "Cítrico limpio y deportivo con bergamota, artemisa y base amaderada.", notes: ["Bergamota", "Artemisa", "Madera"] },
      { cat: "caballero", name: "Laclass White", inspo: "Lacoste L.12.12 White", brand: "Lacoste", desc: "Fresco y ligero con cítricos, especias suaves y almizcle blanco.", notes: ["Cítricos", "Especias", "Almizcle"] },
      { cat: "caballero", name: "Lmnsitte", inspo: "L'Immensité", brand: "Louis Vuitton", desc: "Marino y amaderado con jengibre, vetiver y notas de madera flotante.", notes: ["Jengibre", "Vetiver", "Madera"] },
      { cat: "caballero", name: "Spirit Nomade", inspo: "Ombre Nomade", brand: "Louis Vuitton", desc: "Oriental oud con oud rojo, rosa y resinas preciosas.", notes: ["Oud", "Rosa", "Resinas"] },
      { cat: "caballero", name: "Beast For Men", inspo: "Animale for Men", brand: "Lyon", desc: "Fougère potente con lavanda, bergamota y musgo de roble.", notes: ["Lavanda", "Bergamota", "Musgo"] },
      { cat: "caballero", name: "Knights Leg", inspo: "Legend de Caballero", brand: "Mont Blanc", desc: "Aromático clásico con bergamota, pino y sándalo cálido.", notes: ["Bergamota", "Pino", "Sándalo"] },
      { cat: "caballero", name: "Heroic Spirit", inspo: "Legend Spirit", brand: "Mont Blanc", desc: "Fresco y deportivo con pomelo, lavanda acuática y musgo.", notes: ["Pomelo", "Lavanda", "Musgo"] },
      { cat: "caballero", name: "Toy Guy", inspo: "Toy Boy", brand: "Moschino", desc: "Floral especiado moderno con pimienta rosa, orquídea y ámbar.", notes: ["Pimienta rosa", "Orquídea", "Ámbar"] },
      { cat: "caballero", name: "Nautic Journey", inspo: "Nautica Voyage", brand: "Nautica", desc: "Marino acuático con notas de manzana, menta y cedro oceánico.", notes: ["Manzana", "Menta", "Cedro"] },
      { cat: "caballero", name: "Invincible", inspo: "Invictus", brand: "Paco Rabanne", desc: "Fresco deportivo con pomelo, laurel marino y guayaco.", notes: ["Pomelo", "Laurel", "Guayaco"] },
      { cat: "caballero", name: "Invincible Legend", inspo: "Invictus Legend EDP", brand: "Paco Rabanne", desc: "Oscuro y magnético con ambergris, carda y notas marinas profundas.", notes: ["Ambergris", "Cardamomo", "Marino"] },
      { cat: "caballero", name: "Specter", inspo: "Phantom", brand: "Paco Rabanne", desc: "Futurista y fresco: lavanda, limón y vainilla robótica.", notes: ["Lavanda", "Limón", "Vainilla"] },
      { cat: "caballero", name: "Invincible Plat", inspo: "Invictus Platinum", brand: "Paco Rabanne", desc: "Marino cítrico con bergamota, jengibre y madera de cachemira.", notes: ["Bergamota", "Jengibre", "Cachemira"] },
      { cat: "caballero", name: "Lux Millon", inspo: "1 Million", brand: "Paco Rabanne", desc: "Especiado y dorado con canela, cuero y patchouli brillante.", notes: ["Canela", "Cuero", "Patchouli"] },
      { cat: "caballero", name: "Hilton Hom", inspo: "Paris Hilton Men", brand: "Paris Hilton", desc: "Cítrico maduro con mandarina, especias orientales y madera.", notes: ["Mandarina", "Especias", "Madera"] },
      { cat: "caballero", name: "Brave Red", inspo: "Perry Ellis Bold Red", brand: "Perry Ellis", desc: "Fresco especiado con bayas rojas, pimienta y cedro rojo.", notes: ["Bayas", "Pimienta", "Cedro"] },
      { cat: "caballero", name: "Polo Ultimate Blu", inspo: "Polo Ultra Blue", brand: "Ralph Lauren", desc: "Marino sofisticado con cardamomo, agua de mar y almizcle blanco.", notes: ["Cardamomo", "Marino", "Almizcle"] },
      { cat: "caballero", name: "Blue Breeze", inspo: "Polo Blue", brand: "Ralph Lauren", desc: "Acuático clásico con melón, pepino y vetiver marino.", notes: ["Melón", "Pepino", "Vetiver"] },
      { cat: "caballero", name: "Pol Crimson", inspo: "Polo Red", brand: "Ralph Lauren", desc: "Cítrico especiado con mandarina, laurel y madera roja.", notes: ["Mandarina", "Laurel", "Madera"] },
      { cat: "caballero", name: "Tom Men", inspo: "Tommy for Men", brand: "Tommy Hilfiger", desc: "Fougère americano con bergamota, menta y base de madera.", notes: ["Bergamota", "Menta", "Madera"] },
      { cat: "caballero", name: "Rom Valentin Green", inspo: "Valentino Uomo Born in Roma Green Stravaganza", brand: "Valentino", desc: "Verde y fresco con lima, té verde y base de vetiver.", notes: ["Lima", "Té verde", "Vetiver"] },
      { cat: "caballero", name: "Rom Valentin", inspo: "Valentino Uomo Born in Roma", brand: "Valentino", desc: "Moderno e intenso con lavanda, madera de vainilla y cuero.", notes: ["Lavanda", "Vainilla", "Cuero"] },
      { cat: "caballero", name: "Cupid Versa", inspo: "Eros", brand: "Versace", desc: "Seductor y fresco con menta, manzana verde y tonka.", notes: ["Menta", "Manzana", "Tonka"] },
      { cat: "caballero", name: "Chill Water", inspo: "Cool Water Men", brand: "Davidoff", desc: "Icónico marino: lavanda acuática, menta y musgo de roble.", notes: ["Lavanda", "Menta", "Musgo"] },

      // UNISEX
      { cat: "unisex", name: "Red Bacara", inspo: "Baccarat Rouge 540", brand: "Maison Francis Kurkdjian", desc: "El perfume de culto: jasmin saffrané, cedro de ambergris y notas florales rojas.", notes: ["Jazmín", "Cedro", "Ámbar"] },
      { cat: "unisex", name: "Unity Calv", inspo: "CK One", brand: "Calvin Klein", desc: "Fresco y unificador: té verde, bergamota, papaya y musgo limpio.", notes: ["Té verde", "Bergamota", "Musgo"] },
      { cat: "unisex", name: "Kahara", inspo: "Khamra", brand: "Lattafa", desc: "Oriental amaderado con vino de oud, rosas y especias cálidas.", notes: ["Oud", "Rosa", "Especias"] },
      { cat: "unisex", name: "Lavander Rush", inspo: "Lavande 31", brand: "Le Labo", desc: "Lavanda pura e intensa con clavos de olor, vetiver y madera.", notes: ["Lavanda", "Clavo", "Vetiver"] },
      { cat: "unisex", name: "Cherrytom", inspo: "Lost Cherry", brand: "Tom Ford", desc: "Cereza oscura y embriagadora con almendra de cereza, pachulí y tonka.", notes: ["Cereza", "Almendra", "Tonka"] },
      { cat: "unisex", name: "Pacific", inspo: "Pacific Chill", brand: "Louis Vuitton", desc: "Cítrico marino refrescante con yuzu, lima y algas cristalinas.", notes: ["Yuzu", "Lima", "Algas"] },
      { cat: "unisex", name: "Sandalwood", inspo: "Santal 33", brand: "Le Labo", desc: "El sándalo moderno icónico: violeta, cardamomo, cedro y cuero.", notes: ["Sándalo", "Cardamomo", "Cuero"] },
      { cat: "unisex", name: "Tobacco Essence", inspo: "Tobacco Vanille", brand: "Tom Ford", desc: "Tabaco especiado y goloso con vainilla, tonka y especias orientales.", notes: ["Tabaco", "Vainilla", "Tonka"] },
      { cat: "unisex", name: "Amber Leather", inspo: "Tuscan Leather", brand: "Tom Ford", desc: "Cuero crudo e intenso con frambuesa, azafrán y alquitrán de abedul.", notes: ["Cuero", "Frambuesa", "Azafrán"] }
    ];

const catLabels = { dama: "Dama", caballero: "Hombre", unisex: "Unisex" };
const catOrder = ["dama", "caballero", "unisex"];

const badgeMap = {
  BLUSH: "Nuevo",
  "Bur Gold": "Más vendido",
  "Valentino Girl": "Más vendido",
  "Free Intense": "Favorito",
  "Rom Valentin": "Más vendido",
  Lmnsitte: "Favorito",
  Sandalwood: "Más vendido",
  Pacific: "Favorito",
  "Red Bacara": "Más vendido",
  "Blue Sea": "Favorito",
  "Wild EDP": "Más vendido",
  Kahara: "Más vendido",
};

function getProfile(p) {
  const text = `${p.desc} ${p.notes.join(" ")} ${p.inspo}`.toLowerCase();

  if (
    text.includes("vainilla") ||
    text.includes("cacao") ||
    text.includes("almendra") ||
    text.includes("cherry") ||
    text.includes("khamra") ||
    text.includes("tobacco")
  ) return "Dulce";

  if (
    text.includes("acqua") ||
    text.includes("marine") ||
    text.includes("profondo") ||
    text.includes("bergamota") ||
    text.includes("cítrico") ||
    text.includes("citrus") ||
    text.includes("cool water") ||
    text.includes("ultra blue")
  ) return "Fresco";

  if (
    text.includes("cuero") ||
    text.includes("leather") ||
    text.includes("nomade") ||
    text.includes("noir") ||
    text.includes("black") ||
    text.includes("intense") ||
    text.includes("elixir")
  ) return "Intenso";

  if (
    text.includes("rosa") ||
    text.includes("jazmín") ||
    text.includes("floral") ||
    text.includes("peonía") ||
    text.includes("iris") ||
    text.includes("gardenia")
  ) return "Floral";

  if (
    text.includes("sándalo") ||
    text.includes("madera") ||
    text.includes("cedro") ||
    text.includes("santal")
  ) return "Amaderado";

  return p.cat === "caballero" ? "Versátil" : "Elegante";
}

function getIdealFor(p) {
  const profile = getProfile(p);
  const text = `${p.desc} ${p.notes.join(" ")} ${p.inspo}`.toLowerCase();

  if (p.name === "BLUSH") return "regalo, citas y momentos románticos";
  if (p.cat === "unisex" && (text.includes("cuero") || text.includes("tobacco") || text.includes("nomade"))) {
    return "noche, looks elegantes y clima fresco";
  }
  if (p.cat === "caballero" && (profile === "Fresco" || text.includes("marine") || text.includes("acqua"))) {
    return "diario, oficina y clima cálido";
  }
  if (p.cat === "caballero" && (profile === "Intenso" || text.includes("elixir") || text.includes("black"))) {
    return "noche, salidas y presencia fuerte";
  }
  if (p.cat === "dama" && (profile === "Dulce" || text.includes("vainilla") || text.includes("lychee"))) {
    return "citas, tarde-noche y clima fresco";
  }
  if (p.cat === "dama" && profile === "Floral") {
    return "uso diario, oficina y regalo femenino";
  }
  if (p.cat === "unisex" && profile === "Fresco") {
    return "uso diario, clima cálido y estilo limpio";
  }

  return "diario y ocasiones especiales";
}

function getBadge(p) {
  return badgeMap[p.name] || "";
}

function getCategoryLine(p) {
  if (p.name === "BLUSH") return "Dama • Dulces";
  return `${catLabels[p.cat]} • ${getProfile(p)}`;
}

function getWhatsAppLink(p) {
  const message = `Hola, me interesa ${p.name} inspirado en ${p.inspo} de ${p.brand}. ¿Lo tienes disponible?`;
  return `https://wa.me/523331300127?text=${encodeURIComponent(message)}`;
}

const CatalogScreen = () => {
  const [currentFilter, setCurrentFilter] = useState("all");
  const [currentSearch, setCurrentSearch] = useState("");

  const filtered = useMemo(() => {
    return perfumes.filter((p) => {
      const matchesCat = currentFilter === "all" || p.cat === currentFilter;
      const q = currentSearch.trim().toLowerCase();

      const matchesSearch =
        !q ||
        p.name.toLowerCase().includes(q) ||
        p.inspo.toLowerCase().includes(q) ||
        p.brand.toLowerCase().includes(q) ||
        p.desc.toLowerCase().includes(q) ||
        p.notes.some((n) => n.toLowerCase().includes(q));

      return matchesCat && matchesSearch;
    });
  }, [currentFilter, currentSearch]);

  const grouped = useMemo(() => {
    const result = { dama: [], caballero: [], unisex: [] };
    filtered.forEach((p) => {
      if (result[p.cat]) result[p.cat].push(p);
    });
    return result;
  }, [filtered]);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Jost:wght@200;300;400;500&display=swap');

        :root {
          --cream: #f5f0e8;
          --dark: #1a1410;
          --gold: #b8933a;
          --gold-light: #d4af6a;
          --blush: #e8d5c4;
          --muted: #7a6e62;
          --card-bg: #faf7f2;
        }

        .catalog-screen * {
          box-sizing: border-box;
        }

        .catalog-screen {
          background: var(--cream);
          color: var(--dark);
          font-family: "Jost", sans-serif;
          font-weight: 300;
          min-height: 100vh;
          padding-bottom: 3rem;
        }

        .catalog-header {
          background: var(--dark);
          padding: 3rem 2rem 2.5rem;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .catalog-header::before {
          content: "";
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse at 60% 0%, rgba(184,147,58,0.18) 0%, transparent 70%);
        }

        .brand-logo {
          position: relative;
          display: block;
          margin: 0 auto;
          height: clamp(70px, 14vw, 120px);
          width: auto;
          filter: brightness(0) invert(1);
        }

        .header-tagline {
          margin-top: 1.8rem;
          font-family: "Cormorant Garamond", serif;
          font-style: italic;
          font-size: clamp(0.9rem, 2.5vw, 1.15rem);
          color: rgba(245,240,232,0.6);
          letter-spacing: 0.05em;
          position: relative;
        }

        .header-divider {
          width: 60px;
          height: 1px;
          background: linear-gradient(90deg, transparent, var(--gold), transparent);
          margin: 1.5rem auto 0;
          position: relative;
        }

        .shipping-banner {
          max-width: 900px;
          margin: 1.2rem auto 0;
          padding: 0.9rem 1.2rem;
          background: linear-gradient(90deg, rgba(184,147,58,0.14), rgba(184,147,58,0.07));
          border: 1px solid rgba(184,147,58,0.28);
          color: var(--dark);
          text-align: center;
          font-size: 0.82rem;
          letter-spacing: 0.18em;
          text-transform: uppercase;
        }

        .value-strip {
          max-width: 900px;
          margin: 0.9rem auto 0;
          padding: 0 1.5rem;
          display: flex;
          gap: 0.6rem;
          flex-wrap: wrap;
          justify-content: center;
        }

        .value-pill {
          padding: 0.55rem 0.9rem;
          border: 1px solid rgba(184,147,58,0.22);
          background: rgba(255,255,255,0.55);
          color: var(--muted);
          font-size: 0.68rem;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          border-radius: 999px;
        }

        .hero-visual {
          max-width: 900px;
          margin: 1.2rem auto 0;
          padding: 0 1.5rem;
        }

        .hero-card {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 14px;
        }

        .hero-image-wrap {
          min-height: 420px;
          border-radius: 18px;
          overflow: hidden;
          background: linear-gradient(135deg, rgba(184,147,58,0.08), rgba(255,255,255,0.35));
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .hero-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .hero-copy {
          padding: 1rem 0 1rem 0.5rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .hero-eyebrow {
          font-size: 0.72rem;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 0.8rem;
        }

        .hero-copy h2 {
          font-family: "Cormorant Garamond", serif;
          font-size: clamp(2rem, 4vw, 3rem);
          line-height: 0.98;
          font-weight: 400;
          color: var(--dark);
          margin-bottom: 0.95rem;
        }

        .hero-copy p {
          font-size: 0.93rem;
          line-height: 1.8;
          color: var(--muted);
          margin-bottom: 1rem;
          max-width: 420px;
        }

        .hero-points {
          display: flex;
          flex-wrap: wrap;
          gap: 0.55rem;
          margin-bottom: 1.15rem;
        }

        .hero-point {
          border: 1px solid rgba(184,147,58,0.2);
          background: rgba(255,255,255,0.75);
          border-radius: 999px;
          padding: 0.42rem 0.78rem;
          font-size: 0.65rem;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: var(--muted);
        }

        .hero-cta {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 0.9rem 1.15rem;
          border-radius: 14px;
          text-decoration: none;
          background: var(--dark);
          color: var(--gold-light);
          border: 1px solid var(--dark);
          letter-spacing: 0.16em;
          text-transform: uppercase;
          font-size: 0.72rem;
          width: fit-content;
        }

        .controls {
          padding: 2rem 1.5rem 1rem;
          max-width: 900px;
          margin: 0 auto;
        }

        .catalog-intro {
          margin-bottom: 1.35rem;
        }

        .catalog-kicker {
          font-size: 0.7rem;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 0.55rem;
        }

        .catalog-intro h1 {
          font-family: "Cormorant Garamond", serif;
          font-size: clamp(1.7rem, 4vw, 2.4rem);
          font-weight: 400;
          line-height: 1.05;
          margin-bottom: 0.55rem;
          color: var(--dark);
        }

        .catalog-intro p {
          font-size: 0.88rem;
          line-height: 1.7;
          color: var(--muted);
          max-width: 760px;
        }

        .search-wrap {
          position: relative;
          margin-bottom: 1.2rem;
        }

        .search-input {
          width: 100%;
          padding: 0.9rem 1.2rem 0.9rem 3rem;
          border: 1px solid rgba(184,147,58,0.25);
          border-radius: 2px;
          background: var(--card-bg);
          font-family: "Jost", sans-serif;
          font-weight: 300;
          font-size: 0.9rem;
          color: var(--dark);
          letter-spacing: 0.05em;
          outline: none;
        }

        .search-icon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: var(--gold);
          font-size: 0.85rem;
          pointer-events: none;
        }

        .filters {
          display: flex;
          gap: 0.5rem;
          flex-wrap: wrap;
        }

        .filter-btn {
          padding: 0.45rem 1.2rem;
          border: 1px solid rgba(184,147,58,0.3);
          background: transparent;
          font-family: "Jost", sans-serif;
          font-weight: 300;
          font-size: 0.75rem;
          letter-spacing: 0.15em;
          text-transform: uppercase;
          color: var(--muted);
          cursor: pointer;
          border-radius: 2px;
        }

        .filter-btn.active {
          background: var(--dark);
          border-color: var(--dark);
          color: var(--gold-light);
        }

        .results-count {
          font-size: 0.75rem;
          color: var(--muted);
          letter-spacing: 0.1em;
          margin-top: 1.1rem;
          text-align: left;
        }

        .cat-header {
          max-width: 900px;
          margin: 2.5rem auto 0.5rem;
          padding: 0 1.5rem;
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .cat-header h2 {
          font-family: "Cormorant Garamond", serif;
          font-weight: 300;
          font-size: clamp(1.4rem, 4vw, 2rem);
          letter-spacing: 0.15em;
          color: var(--dark);
          white-space: nowrap;
        }

        .cat-line {
          flex: 1;
          height: 1px;
          background: linear-gradient(90deg, rgba(184,147,58,0.3), transparent);
        }

        .cat-count {
          font-size: 0.7rem;
          color: var(--muted);
          letter-spacing: 0.1em;
        }

        .grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
          gap: 14px;
          max-width: 900px;
          margin: 0 auto 1rem;
          padding: 0 1.5rem;
        }

        .card {
          background: var(--card-bg);
          border: 1px solid rgba(184,147,58,0.13);
          border-radius: 18px;
          padding: 1.25rem 1.15rem 1.1rem;
          box-shadow: 0 10px 25px rgba(26,20,16,0.04);
          overflow: hidden;
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .card-top {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 0.75rem;
        }

        .card-cat {
          font-size: 0.6rem;
          letter-spacing: 0.25em;
          text-transform: uppercase;
          color: var(--gold);
          font-weight: 400;
        }

        .card-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 0.28rem 0.56rem;
          border-radius: 999px;
          background: rgba(184,147,58,0.12);
          color: var(--gold);
          font-size: 0.58rem;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          white-space: nowrap;
          border: 1px solid rgba(184,147,58,0.18);
        }

        .card-name {
          font-family: "Cormorant Garamond", serif;
          font-size: 1.3rem;
          font-weight: 400;
          line-height: 1.2;
          color: var(--dark);
        }

        .card-price-row {
          display: flex;
          align-items: center;
          gap: 0.55rem;
          flex-wrap: wrap;
          margin-top: 0.25rem;
        }

        .card-price {
          font-size: 1rem;
          color: #b8933a;
          letter-spacing: 0.06em;
          font-weight: 500;
        }

        .card-volume {
          display: inline-flex;
          align-items: center;
          padding: 0.2rem 0.55rem;
          border-radius: 999px;
          font-size: 0.62rem;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: var(--muted);
          border: 1px solid rgba(122,110,98,0.18);
          background: rgba(245,240,232,0.8);
        }

        .card-inspo {
          font-family: "Cormorant Garamond", serif;
          font-style: italic;
          font-size: 0.92rem;
          color: var(--muted);
        }

        .card-brand {
          font-size: 0.68rem;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: rgba(122,110,98,0.7);
          margin-top: -0.05rem;
        }

        .card-divider {
          height: 1px;
          background: linear-gradient(90deg, var(--gold-light), transparent);
          opacity: 0.3;
          margin: 0.4rem 0;
        }

        .card-desc,
        .card-profile,
        .card-ideal {
          font-size: 0.72rem;
          line-height: 1.6;
          color: var(--muted);
        }

        .card-profile strong,
        .card-ideal strong {
          color: var(--dark);
          font-weight: 400;
        }

        .card-notes {
          display: flex;
          flex-wrap: wrap;
          gap: 0.3rem;
          margin-top: 0.1rem;
        }

        .note-tag {
          font-size: 0.62rem;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          padding: 0.2rem 0.55rem;
          border: 1px solid rgba(184,147,58,0.25);
          color: var(--gold);
          border-radius: 1px;
        }

        .card-actions {
          margin-top: 0.95rem;
        }

        .btn-consultar {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          padding: 0.82rem 1rem;
          border: 1px solid rgba(184,147,58,0.4);
          color: var(--gold);
          font-size: 0.72rem;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          background: transparent;
          border-radius: 12px;
          text-decoration: none;
          font-weight: 400;
        }

        .card-mini {
          margin-top: 0.55rem;
          font-size: 0.62rem;
          color: rgba(122,110,98,0.95);
          letter-spacing: 0.1em;
          text-transform: uppercase;
          text-align: center;
        }

        .empty {
          text-align: center;
          padding: 4rem 2rem;
          color: var(--muted);
          font-style: italic;
          font-family: "Cormorant Garamond", serif;
          font-size: 1.1rem;
        }

        .whatsapp-float {
          position: fixed;
          right: 20px;
          bottom: 20px;
          background: #25d366;
          color: white;
          padding: 14px 20px;
          border-radius: 999px;
          font-size: 0.8rem;
          letter-spacing: 0.1em;
          text-decoration: none;
          box-shadow: 0 8px 20px rgba(0,0,0,0.2);
          z-index: 999;
          font-weight: 500;
        }
      `}</style>

      <div className="catalog-screen">
        <header className="catalog-header">
          {/* <img className="brand-logo" src={hadaLogo} alt="HADACY logo" /> */}
          <div className="header-tagline">
            Encuentra aromas icónicos en presentación de 100 mL, listos para pedir por WhatsApp
          </div>
          <div className="header-divider"></div>
        </header>

        <section className="shipping-banner">
          ENVÍO GRATIS en la compra de 2 perfumes o más
        </section>

        <section className="value-strip">
          <div className="value-pill">100 mL en cada perfume</div>
          <div className="value-pill">Más de 100 aromas disponibles</div>
          <div className="value-pill">Compra rápida por WhatsApp</div>
        </section>

        <section className="hero-visual">
          <div className="hero-card">
            {/* <div className="hero-image-wrap"> */}
              {/* <img className="hero-image" src={heroImage} alt="Perfume destacado HADACY" /> */}
              {/* <img className="hero-image" src={hadaLogo} alt="Perfume destacado HADACY" />
            </div> */}

            <div className="hero-copy">
              <div className="hero-eyebrow">HADACY Parfum</div>
              <h2>Tu próximo perfume favorito está aquí</h2>
              <p>
                Perfumes inspirados en fragancias icónicas.
                <br />
                Lujo accesible en cada aroma.
              </p>

              <div className="hero-points">
                <span className="hero-point">Duración alta</span>
                <span className="hero-point">100 mL</span>
                <span className="hero-point">Más de 100 aromas</span>
              </div>

              <a href="#catalogo" className="hero-cta">Explorar catálogo</a>
            </div>
          </div>
        </section>

        <div className="controls" id="catalogo">
          <div className="catalog-intro">
            <p className="catalog-kicker">Catálogo HADACY</p>
            <h1>Elige por estilo, inspiración o notas olfativas</h1>
            <p>
              Cada tarjeta está pensada para ayudarte a decidir más rápido:
              verás el perfil del aroma, para qué ocasión funciona mejor
              y un botón directo para pedirlo.
            </p>
          </div>

          <div className="search-wrap">
            <span className="search-icon">&#9675;</span>
            <input
              className="search-input"
              type="text"
              value={currentSearch}
              onChange={(e) => setCurrentSearch(e.target.value)}
              placeholder="Busca por nombre, inspiración, marca o notas..."
            />
          </div>

          <div className="filters">
            <button className={`filter-btn ${currentFilter === "all" ? "active" : ""}`} onClick={() => setCurrentFilter("all")}>
              Todos
            </button>
            <button className={`filter-btn ${currentFilter === "dama" ? "active" : ""}`} onClick={() => setCurrentFilter("dama")}>
              Dama
            </button>
            <button className={`filter-btn ${currentFilter === "caballero" ? "active" : ""}`} onClick={() => setCurrentFilter("caballero")}>
              Hombre
            </button>
            <button className={`filter-btn ${currentFilter === "unisex" ? "active" : ""}`} onClick={() => setCurrentFilter("unisex")}>
              Unisex
            </button>
          </div>

          <div className="results-count">
            {filtered.length === 0
              ? "No encontramos coincidencias. Prueba con otra inspiración o nota olfativa."
              : `${filtered.length} fragancia${filtered.length !== 1 ? "s" : ""} disponible${filtered.length !== 1 ? "s" : ""}`}
          </div>
        </div>

        {catOrder.map((cat) => {
          if (!grouped[cat]?.length) return null;

          return (
            <React.Fragment key={cat}>
              <div className="cat-header">
                <h2>{catLabels[cat]}</h2>
                <div className="cat-line"></div>
                <span className="cat-count">{grouped[cat].length}</span>
              </div>

              <div className="grid">
                {grouped[cat].map((p, i) => {
                  const badge = getBadge(p);

                  return (
                    <div className="card" key={`${p.name}-${i}`}>
                      <div className="card-top">
                        <div className="card-cat">{getCategoryLine(p)}</div>
                        {badge ? <div className="card-badge">{badge}</div> : null}
                      </div>

                      <div className="card-name">{p.name}</div>

                      <div className="card-price-row">
                        <div className="card-price">$399 MXN</div>
                        <div className="card-volume">100 mL</div>
                      </div>

                      <div className="card-inspo">inspirado en {p.inspo}</div>
                      <div className="card-brand">{p.brand}</div>
                      <div className="card-divider"></div>
                      <div className="card-desc">{p.desc}</div>
                      <div className="card-profile"><strong>Perfil:</strong> {getProfile(p)}</div>
                      <div className="card-ideal"><strong>Ideal para:</strong> {getIdealFor(p)}</div>

                      <div className="card-notes">
                        {p.notes.map((note) => (
                          <span className="note-tag" key={note}>{note}</span>
                        ))}
                      </div>

                      <div className="card-actions">
                        <a
                          className="btn-consultar"
                          href={getWhatsAppLink(p)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Quiero este perfume
                        </a>
                        <div className="card-mini">Envío gratis en la compra de 2+ perfumes</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </React.Fragment>
          );
        })}

        {filtered.length === 0 && (
          <div className="grid">
            <div className="empty">No encontramos fragancias con ese término.</div>
          </div>
        )}

        <a
          className="whatsapp-float"
          href="https://wa.me/523331300127"
          target="_blank"
          rel="noopener noreferrer"
        >
          Comprar por WhatsApp
        </a>
      </div>
    </>
  );
};

export default CatalogScreen;